import { render, staticRenderFns } from "./GenerateReportFBAPageTableMobile.vue?vue&type=template&id=120cfefc&scoped=true"
import script from "./GenerateReportFBAPageTableMobile.vue?vue&type=script&lang=js"
export * from "./GenerateReportFBAPageTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120cfefc",
  null
  
)

export default component.exports